<div class="out">
  <input kzInput #input autoFocus [tabindex]="tabindex" class="fback" [style.width]="width" [autocomplete]="autocomplete" [type]="type" [placeholder]="display_placeholder" [(ngModel)]="_model" #emailref="ngModel" [ngClass]="{invalid:bInvalid}"
    (ngModelChange)="modelChanged($event)" (keyup)="keyUp($event)" (keydown)="keyDown($event)" (blur)="lostFocus()">
</div>
